import { render, staticRenderFns } from "./EditPolicy.vue?vue&type=template&id=b70cdc44"
import script from "./EditPolicy.vue?vue&type=script&lang=js"
export * from "./EditPolicy.vue?vue&type=script&lang=js"
import style0 from "./EditPolicy.vue?vue&type=style&index=0&id=b70cdc44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports